import React, { Component } from 'react';

import { MinimizedWindowStatusItem } from './MinimizedWindowStatusItem/MinimizedWindowStatusItem';
import { LayoutContext } from '../../../modules/ContextModules/LayoutContext';
import './MinimizedWindowStatusBar.css'
export class MinimizedWindowStatusBar extends Component {
    static contextType = LayoutContext;

    render() {
        return (
            <div className='minimizedWindowStatusBar'>
                {
                    this.props.data.minimizedStatusStack.map(key=>{
                        let item = this.props.data[key];
                        item.contextKey = key;
                        return <MinimizedWindowStatusItem key={item.name} data={item} handleBodyClick={this.handleBodyClick} handleCancel={this.handleCancel}/>
                    })
                }
            </div>
        );        
    }

    handleBodyClick = (data) => {
        this.context
        .draggableWindowContext[data.contextKey]
        .update({
            isOpened: true,
            isMinimized: !data.isMinimized
        });
    }

    handleCancel = (data) => {
        this.context
        .draggableWindowContext[data.contextKey]
        .update({
            isOpened: false
        });
    }
}